// features/organization/department/departmentService.js

import apiClient from "../shared/API/apiClient";

//GET Department List
export const getDepartments = async () => {
  const res = await apiClient.get("/api/department-list");
  return res.data;
};